<button [disabled]="isLoading || disabled" mat-raised-button [color]="color" (click)="buttonClicked()">
  <span [fxHide]="isLoading">
    <ng-content></ng-content>
  </span>
  <mat-spinner [fxHide]="!isLoading" diameter="20"></mat-spinner>
</button>
